import {
    DashboardWidgetModel,
    DashboardWidgetType
} from '@/atomic-components/organs/dashboard-widgets/dashboard-widget-model';
import {
    DashboardWidgetObjectDefinition
} from '@/atomic-components/organs/dashboard-widgets/dashboard-widget-model-operator';

export class DashboardWidgetSupportModel extends DashboardWidgetModel {
    public static $inject: string[] = DashboardWidgetModel.$inject.concat([]);

    public static dashboardWidgetDefinition: DashboardWidgetObjectDefinition = {
        demoData: {},
        manualAddable: true,
        userPermissions: null,
        widgetDescription: [
            /* translationId */ 'TR_281021-eb51db_TR'
        ],
        widgetObject: {
            attribute: {
                id: 'organDashboardWidgetSupport',
                width: 1,
                height: 1,
                x: 0,
                y: 0,
                noResize: true,
                autoPosition: true
            },
            componentTagName: 'organ-dashboard-widget-support',
            widgetModel: 'dashboardWidgetSupportModel',
            version: '1.0'
        },
        widgetTitle: /* translationId */ '04eb7dd0-592e-4f4e-97da-82fdb3727f2d',
        widgetType: DashboardWidgetType.custom
    };

    public dashboardWidgetDefinition: DashboardWidgetObjectDefinition;

    constructor() {
        super();

        this.dashboardWidgetDefinition = DashboardWidgetSupportModel.dashboardWidgetDefinition;
    }
}
